import EntityUrl from '../EntityUrl';

class GameUrl extends EntityUrl {
    getRelativePath(id: number): string {
        return `/games/${id}`;
    }
}

export default GameUrl;

